import React from 'react'
import {
  BoolField,
  NumberField,
  SelectField,
  SwitchField,
  TextField,
  TextareaField,
  DateField,
} from './fields'

import './Field.scss'

const Field = (props) => {
  switch (props.type) {
    case 'textarea': return <TextareaField {...props} />
    case 'number': return <NumberField {...props} />
    case 'switch': return <SwitchField {...props} />
    case 'select': return <SelectField {...props} />
    case 'checkbox': return <BoolField {...props} />
    case 'date': return <DateField {...props} />
    case 'datetime': return <DateField showTime {...props} />
    default: return <TextField {...props} />
  }
}

Field.defaultProps = {
  type: 'text',
}

Field.propTypes = {
  type: React.PropTypes.string,
}

export default Field



// WEBPACK FOOTER //
// ./src/browser/components/Field.js